import { HistoryRecord } from './history-record';
import { UserOverview } from './user';

export type FYIDocumentMetadata = {
    id: string;
    versionId: string;
    externalId: string;
    documentType: string;
    workpaperId?: string;
};

export enum FileStatusEnum {
    CHECKED_IN = 'CHECKED_IN',
    CHECKED_OUT = 'CHECKED_OUT',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}
export enum FileRecordTypeEnum {
    DOCUMENT = 'DOCUMENT',
    LINK = 'LINK',
    FOLDER = 'FOLDER',
    REFERENCE = 'REFERENCE',
    FYI_DOCUMENT = 'FYI_DOCUMENT',
    FOLDER_REFERENCE = 'FOLDER_REFERENCE',
}

export type FilePathNode = {
    level: number;
    folders: {
        name: string;
        id: string;
    }[];
};

export type FilePath = FilePathNode[];

export enum FileContextEnum {
    FIRM = 'FIRM',
    GROUP = 'GROUP',
    ENTITY = 'ENTITY',
    WORKPAPER = 'WORKPAPER',
    WORKSHEET = 'WORKSHEET',
    OTHER_SCHEDULE = 'OTHER_SCHEDULE',
}

export type FileRecord = {
    id: string;
    parentFolderId?: string[];
    name: string;
    mimeType?: string;
    bytes?: number;
    status: FileStatusEnum;
    context?: FileContextEnum | null;
    recordType: FileRecordTypeEnum;
    link?: string;
    s3Key?: string;
    itemCount?: number | null;
    source?: {
        id: string;
        name: string;
        recordType: FileRecordTypeEnum;
        link?: string;
        mimeType?: string;
        metadata?: FYIDocumentMetadata;
    };
    systemRecord?: boolean;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: UserOverview;
    description?: string | null;
    hidden: boolean;
    history: HistoryRecord[];
    path?: FilePath;
    metadata?: FYIDocumentMetadata;
    locked: boolean;
};

export type FileRecordOverview = Pick<
    FileRecord,
    | 'id'
    | 'parentFolderId'
    | 'name'
    | 'status'
    | 'recordType'
    | 'itemCount'
    | 'source'
    | 'systemRecord'
    | 'createdAt'
    | 'updatedAt'
    | 'link'
    | 'mimeType'
    | 'path'
    | 'hidden'
    | 'metadata'
    | 'locked'
>;

export type PathNode = {
    id: string;
    name: string;
    level: number;
    locked: boolean;
    context?: FileContextEnum | null;
    provider?: string;
};

export type FileRecordNew = {
    id: string;
    firmId: string;
    name: string;
    path: PathNode[];
    context?: FileContextEnum | null;
    description: string | null;
    status: FileStatusEnum;
    recordType: FileRecordTypeEnum;
    systemRecord: boolean;
    createdAt: Date;
    updatedAt: Date;
    createdBy: UserOverview | null;
    hidden: boolean;
    mimeType: string | null;
    bytes: number | null;
    s3Key: string | null;
    link: string | null;
    itemCount: number | null;
    source: FileRecordNew | null;
    providerId: string | null;
    provider: string | null;
    metadata: FYIDocumentMetadata | null;
    locked: boolean;
};
